module.exports = __webpack_public_path__ + "img/shiba-loading.860df2f7.png";